// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MI detail pages — aligned with filing-details-page / report-card / kpi-banner */

.mi-detail-page {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.mi-detail-page .mi-detail-topbar {
  flex-shrink: 0;
  align-items: flex-start;
  gap: 20px;
  animation: filingsInsightsIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;
}

.mi-detail-page .mi-detail-content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 32px;
  animation: filingsInsightsIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;
}

.mi-detail-page .mi-detail-content--state {
  padding-top: 24px;
}

.mi-detail-topbar__left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  min-width: 0;
  flex: 1 1;
}

.mi-detail-topbar__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding-top: 22px;
}

.mi-detail-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  white-space: nowrap;
}

.mi-detail-hero {
  margin-top: 6px;
  min-width: 0;
}

.mi-detail-hero__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.mi-detail-hero__title {
  margin: 0;
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.35px;
  color: var(--c-black);
  max-width: 52rem;
}

.mi-detail-hero__subtitle {
  margin: 6px 0 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--text2);
  line-height: 1.4;
}

.mi-detail-hero__ref {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0;
}

.mi-detail-hero__ref-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text3);
}

.mi-detail-hero__ref-value {
  font-family: var(--mono);
  font-size: 12px;
  font-weight: 500;
  color: var(--c-blue-1);
  word-break: break-all;
}

.mi-detail-platform-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  border: 1px solid transparent;
}

.mi-detail-platform-chip--linkedin {
  background: var(--bg-blue-soft);
  color: var(--c-blue-1);
  border-color: rgba(37, 99, 235, 0.12);
}

.mi-detail-platform-chip--meta {
  background: var(--bg-purple-soft, #f3f0ff);
  color: var(--c-purple-1, #5b21b6);
  border-color: rgba(91, 33, 182, 0.12);
}

.mi-detail-platform-chip--google {
  background: color-mix(in srgb, #1a7f4b 10%, transparent);
  color: #1a7f4b;
  border-color: rgba(26, 127, 75, 0.15);
}

.mi-detail-status-pill {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid transparent;
}

.mi-detail-status-pill--active {
  background: var(--bg-teal-soft);
  color: var(--c-teal-active);
  border-color: rgba(13, 148, 136, 0.15);
}

.mi-detail-status-pill--inactive {
  background: var(--bg2, #f4f4f5);
  color: var(--text2);
  border-color: var(--border);
}

.mi-detail-page .mi-detail-kpis {
  margin-bottom: 4px;
}

.mi-detail-page .mi-detail-kpis > * {
  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.mi-detail-page .mi-detail-kpis > *:nth-child(1) { animation-delay: 0.1s; }
.mi-detail-page .mi-detail-kpis > *:nth-child(2) { animation-delay: 0.14s; }
.mi-detail-page .mi-detail-kpis > *:nth-child(3) { animation-delay: 0.18s; }
.mi-detail-page .mi-detail-kpis > *:nth-child(4) { animation-delay: 0.22s; }

.mi-detail-section {
  margin: 0;
  padding: 18px 20px 20px;
  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.mi-detail-page .mi-detail-content > .mi-detail-grid {
  animation-delay: 0.18s;
}

.mi-detail-page .mi-detail-content > .mi-detail-section {
  animation-delay: 0.24s;
}

.mi-detail-page .mi-detail-content > .mi-detail-section:nth-of-type(n + 2) {
  animation-delay: 0.3s;
}

.mi-detail-section__title {
  margin: 0 0 14px;
  padding-bottom: 10px;
}

.mi-detail-section__body {
  padding: 0 2px;
}

.mi-detail-grid {
  display: grid;
  grid-template-columns: minmax(300px, 400px) 1fr;
  gap: 16px;
  align-items: start;
}

.mi-detail-grid .mi-detail-section {
  height: 100%;
  animation-delay: inherit;
}

@media (max-width: 960px) {
  .mi-detail-grid {
    grid-template-columns: 1fr;
  }

  .mi-detail-topbar__actions {
    padding-top: 0;
    width: 100%;
  }
}

.mi-detail-creative-wrap {
  border-radius: var(--border-radius-md, 8px);
  overflow: hidden;
  background: linear-gradient(165deg, var(--bg2, #f4f4f5) 0%, var(--c-white) 100%);
  border: 1px solid var(--border);
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.mi-detail-creative-wrap .marketing-drawer-creative-wrap {
  width: 100%;
}

.mi-detail-creative-wrap .marketing-drawer-creative,
.mi-detail-creative-wrap .ad-creative-thumbnail img {
  width: 100%;
  max-height: 440px;
  object-fit: contain;
}

.mi-detail-creative-empty {
  margin: 0;
  padding: 48px 24px;
  text-align: center;
  font-size: 13px;
  color: var(--text3);
}

.mi-detail-copy-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 4px 2px 2px 16px;
  border-left: 3px solid var(--border);
}

.mi-detail-copy-headline {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.35;
  letter-spacing: -0.2px;
  color: var(--c-black);
}

.mi-detail-copy-body {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: var(--text2);
  white-space: pre-wrap;
}

.mi-detail-fields {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 20px 28px;
}

.mi-detail-field--wide {
  grid-column: 1 / -1;
}

.mi-detail-field__label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 5px;
}

.mi-detail-field__value {
  font-size: 14px;
  font-weight: 500;
  color: var(--c-black);
  line-height: 1.45;
  word-break: break-word;
}

.mi-detail-field__value a {
  color: var(--c-blue-1);
  text-decoration: none;
  font-weight: 500;
}

.mi-detail-field__value a:hover {
  text-decoration: underline;
}

.mi-detail-link-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  border-radius: var(--border-radius-md, 8px);
  background: var(--bg2, #f8f9fa);
  border: 1px solid var(--border);
}

.mi-detail-link-card__label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.mi-detail-link-card__url {
  font-size: 13px;
  line-height: 1.5;
  color: var(--c-blue-1);
  text-decoration: none;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mi-detail-link-card__url:hover {
  text-decoration: underline;
}

.mi-detail-link-card__open {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
}

.mi-detail-news-headline {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.35;
  letter-spacing: -0.25px;
  color: var(--c-black);
}

.mi-detail-news-summary {
  margin: 0;
  font-size: 15px;
  line-height: 1.65;
  color: var(--text2);
  white-space: pre-wrap;
}

.mi-detail-state {
  max-width: 480px;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}

.mi-detail-state__text {
  margin: 0;
  font-size: 14px;
  color: var(--text2);
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/mi/MiDetailLayout.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,gFAAgF;AAClF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,wDAAwD;EACxD,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8EAA8E;AAChF;;AAEA,mDAAmD,qBAAqB,EAAE;AAC1E,mDAAmD,sBAAsB,EAAE;AAC3E,mDAAmD,sBAAsB,EAAE;AAC3E,mDAAmD,sBAAsB,EAAE;;AAE3E;EACE,SAAS;EACT,uBAAuB;EACvB,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,gFAAgF;EAChF,+BAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["/* MI detail pages — aligned with filing-details-page / report-card / kpi-banner */\n\n.mi-detail-page {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.mi-detail-page .mi-detail-topbar {\n  flex-shrink: 0;\n  align-items: flex-start;\n  gap: 20px;\n  animation: filingsInsightsIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;\n}\n\n.mi-detail-page .mi-detail-content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-bottom: 32px;\n  animation: filingsInsightsIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;\n}\n\n.mi-detail-page .mi-detail-content--state {\n  padding-top: 24px;\n}\n\n.mi-detail-topbar__left {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n  min-width: 0;\n  flex: 1;\n}\n\n.mi-detail-topbar__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  padding-top: 22px;\n}\n\n.mi-detail-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.mi-detail-hero {\n  margin-top: 6px;\n  min-width: 0;\n}\n\n.mi-detail-hero__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.mi-detail-hero__title {\n  margin: 0;\n  font-family: var(--font-display);\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 1.3;\n  letter-spacing: -0.35px;\n  color: var(--c-black);\n  max-width: 52rem;\n}\n\n.mi-detail-hero__subtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text2);\n  line-height: 1.4;\n}\n\n.mi-detail-hero__ref {\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 10px 0 0;\n}\n\n.mi-detail-hero__ref-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text3);\n}\n\n.mi-detail-hero__ref-value {\n  font-family: var(--mono);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-blue-1);\n  word-break: break-all;\n}\n\n.mi-detail-platform-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  border: 1px solid transparent;\n}\n\n.mi-detail-platform-chip--linkedin {\n  background: var(--bg-blue-soft);\n  color: var(--c-blue-1);\n  border-color: rgba(37, 99, 235, 0.12);\n}\n\n.mi-detail-platform-chip--meta {\n  background: var(--bg-purple-soft, #f3f0ff);\n  color: var(--c-purple-1, #5b21b6);\n  border-color: rgba(91, 33, 182, 0.12);\n}\n\n.mi-detail-platform-chip--google {\n  background: color-mix(in srgb, #1a7f4b 10%, transparent);\n  color: #1a7f4b;\n  border-color: rgba(26, 127, 75, 0.15);\n}\n\n.mi-detail-status-pill {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 3px 10px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n}\n\n.mi-detail-status-pill--active {\n  background: var(--bg-teal-soft);\n  color: var(--c-teal-active);\n  border-color: rgba(13, 148, 136, 0.15);\n}\n\n.mi-detail-status-pill--inactive {\n  background: var(--bg2, #f4f4f5);\n  color: var(--text2);\n  border-color: var(--border);\n}\n\n.mi-detail-page .mi-detail-kpis {\n  margin-bottom: 4px;\n}\n\n.mi-detail-page .mi-detail-kpis > * {\n  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.mi-detail-page .mi-detail-kpis > *:nth-child(1) { animation-delay: 0.1s; }\n.mi-detail-page .mi-detail-kpis > *:nth-child(2) { animation-delay: 0.14s; }\n.mi-detail-page .mi-detail-kpis > *:nth-child(3) { animation-delay: 0.18s; }\n.mi-detail-page .mi-detail-kpis > *:nth-child(4) { animation-delay: 0.22s; }\n\n.mi-detail-section {\n  margin: 0;\n  padding: 18px 20px 20px;\n  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.mi-detail-page .mi-detail-content > .mi-detail-grid {\n  animation-delay: 0.18s;\n}\n\n.mi-detail-page .mi-detail-content > .mi-detail-section {\n  animation-delay: 0.24s;\n}\n\n.mi-detail-page .mi-detail-content > .mi-detail-section:nth-of-type(n + 2) {\n  animation-delay: 0.3s;\n}\n\n.mi-detail-section__title {\n  margin: 0 0 14px;\n  padding-bottom: 10px;\n}\n\n.mi-detail-section__body {\n  padding: 0 2px;\n}\n\n.mi-detail-grid {\n  display: grid;\n  grid-template-columns: minmax(300px, 400px) 1fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.mi-detail-grid .mi-detail-section {\n  height: 100%;\n  animation-delay: inherit;\n}\n\n@media (max-width: 960px) {\n  .mi-detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mi-detail-topbar__actions {\n    padding-top: 0;\n    width: 100%;\n  }\n}\n\n.mi-detail-creative-wrap {\n  border-radius: var(--border-radius-md, 8px);\n  overflow: hidden;\n  background: linear-gradient(165deg, var(--bg2, #f4f4f5) 0%, var(--c-white) 100%);\n  border: 1px solid var(--border);\n  min-height: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.mi-detail-creative-wrap .marketing-drawer-creative-wrap {\n  width: 100%;\n}\n\n.mi-detail-creative-wrap .marketing-drawer-creative,\n.mi-detail-creative-wrap .ad-creative-thumbnail img {\n  width: 100%;\n  max-height: 440px;\n  object-fit: contain;\n}\n\n.mi-detail-creative-empty {\n  margin: 0;\n  padding: 48px 24px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--text3);\n}\n\n.mi-detail-copy-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 4px 2px 2px 16px;\n  border-left: 3px solid var(--border);\n}\n\n.mi-detail-copy-headline {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.35;\n  letter-spacing: -0.2px;\n  color: var(--c-black);\n}\n\n.mi-detail-copy-body {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.65;\n  color: var(--text2);\n  white-space: pre-wrap;\n}\n\n.mi-detail-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 20px 28px;\n}\n\n.mi-detail-field--wide {\n  grid-column: 1 / -1;\n}\n\n.mi-detail-field__label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 5px;\n}\n\n.mi-detail-field__value {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--c-black);\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.mi-detail-field__value a {\n  color: var(--c-blue-1);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.mi-detail-field__value a:hover {\n  text-decoration: underline;\n}\n\n.mi-detail-link-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px;\n  border-radius: var(--border-radius-md, 8px);\n  background: var(--bg2, #f8f9fa);\n  border: 1px solid var(--border);\n}\n\n.mi-detail-link-card__label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.mi-detail-link-card__url {\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--c-blue-1);\n  text-decoration: none;\n  word-break: break-all;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.mi-detail-link-card__url:hover {\n  text-decoration: underline;\n}\n\n.mi-detail-link-card__open {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  text-decoration: none;\n}\n\n.mi-detail-news-headline {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  line-height: 1.35;\n  letter-spacing: -0.25px;\n  color: var(--c-black);\n}\n\n.mi-detail-news-summary {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.65;\n  color: var(--text2);\n  white-space: pre-wrap;\n}\n\n.mi-detail-state {\n  max-width: 480px;\n  padding: 28px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.mi-detail-state__text {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text2);\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
